import * as P from 'prop-types';

export const ButtonDeviceStepPropTypes = {
  handleClick: P.func.isRequired,
  isActive: P.bool.isRequired,
  label: P.string.isRequired,
};

export default { ButtonDeviceStepPropTypes };
